  // src/pages/Candidates.jsx
  import React, { useEffect, useState } from "react";
  import {
    Box,
    Typography,
    Button,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    TablePagination,
    Drawer,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    CircularProgress,
  } from "@mui/material";
// import Tesseract from "tesseract.js";
import { approveCandidate, checkAadhar,  scanAadhaarOCR } from "../../Api/candidateApi";
  import { BiShow, BiEdit, BiTrash } from "react-icons/bi";
import {
  CheckCircleIcon,
  MagnifyingGlassIcon,
  XCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/solid";

  import {
    getAllCandidates,
    createCandidate,
    updateCandidate,
    deleteCandidate,
    exportCandidates,
  } from "../../Api/candidateApi";
import { getAllProjects, getProgramsByProject} from "../../Api/projectApi";
import { getAllBranches, getMyBranch } from "../../Api/branches";
import toast from "react-hot-toast";
//  import imageCompression from "browser-image-compression";
 import {
  IdentificationIcon,
  DocumentArrowDownIcon,
  CameraIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";
import { logClientAction } from "../../Api/logApi";
import { uploadCandidateCsv } from "../../Api/excelApi";

const emptyCandidate = {
  project: "",
  program:"",
  location: "",
  // status: "",
  batchId: "",
  name: "",
  fathersName: "",
  mothersName: "",
  maritalStatus: "",
  caste: "",
  address: "",
  aadharNumber: "",
  dob: "",
  gender: "",
  religion: "",
  religionOther: "",

  vulnerability: "",
  annualIncome: "",
  qualification: "",
  contactNumber: "",
  assessmentDate: "",
  dlNo: "",
  dlType: "",
  licenseExpiryDate: "",
  dependentFamilyMembers: "",
  ownerOrDriver: "",
  abha: "",
  result: "",
  certificateNo: "",
  remarks: "",
  ekycRemarks: "",
  ekycRegisteredEmail: "",
  barCode: "",
  dlIssueDate: "",
  dlAuthority: "",
  experienceYears: "",
  employerName: "",
  employerAddress: "",

  // ⭐ NEW FILE UPLOAD FIELDS
  aadharFile: "",
  dlFile: "",
  otherFile: "",
};

// 1️⃣ Fields that MUST come first (your required order)
const primaryOrderedFields = [
  "aadharNumber",

  "name",
  "fathersName",
  "mothersName",
  "dob",
  "maritalStatus",
  "religion",
  "caste",
  "annualIncome",
  "address",
  "dlNo",
  "dlIssueDate",
  "licenseExpiryDate",
  "dlType",
  "dlAuthority",
  "contactNumber",
  "qualification",
  "experienceYears",
  "employerName",
  "employerAddress",
];

// 2️⃣ Uploads MUST come last
const uploadFields = ["aadharFile", "dlFile", "otherFile"];

// 3️⃣ Fields already rendered separately
const excludedFields = [
  ...primaryOrderedFields,
  ...uploadFields,
  "project",
  "program",
  // "location",
];

// 4️⃣ Automatically include ALL remaining fields
const remainingFields = Object.keys(emptyCandidate).filter(
  (f) => !excludedFields.includes(f)
);

// ✅ FINAL ORDER (THIS IS WHAT YOU MAP)
const finalFieldOrder = [
  ...primaryOrderedFields,
  ...remainingFields,
  ...uploadFields,
];


  const Candidates = () => {
    const [data, setData] = useState([]);
    const [loadingTable, setLoadingTable] = useState(false);
const role = localStorage.getItem("role"); // "admin" | "branchUser"

    // Drawer & form
    const [openDrawer, setOpenDrawer] = useState(false);
    const [form, setForm] = useState(emptyCandidate);
    const [editingId, setEditingId] = useState(null);
const [exportLoading, setExportLoading] = useState(false);

    // Pagination
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
// const [myBranchLocation, setMyBranchLocation] = useState("");

    // Delete
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    // View popup
    const [viewDialogOpen, setViewDialogOpen] = useState(false);
    const [selectedCandidate, setSelectedCandidate] = useState(null);
    // New state to store unique locations
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
const [projects, setProjects] = useState([]);
const [programs, setPrograms] = useState([]);
const [exportDialog, setExportDialog] = useState(false);
const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");
const [scanDialog, setScanDialog] = useState(false);
const [scanImage, setScanImage] = useState(null);
const [scanning, setScanning] = useState(false);
const optionalFields = ["otherFile"];  
const [aadharDialogOpen, setAadharDialogOpen] = useState(false);
// const [aadharCheckStatus, setAadharCheckStatus] = useState(""); 
 
const [checkAadharValue, setCheckAadharValue] = useState("");
const [aadharCheckStatus, setAadharCheckStatus] = useState(""); // checking | exists | new

const [branchLocations, setBranchLocations] = useState([]);
const videoRef = React.useRef(null);
const canvasRef = React.useRef(null);
const [aadharStatus, setAadharStatus] = useState(null);
 
const [abhaError, setAbhaError] = useState("");
const [contactError, setContactError] = useState("");
const [saving, setSaving] = useState(false);

const [cameraOpen, setCameraOpen] = useState(false);
const [cameraStream, setCameraStream] = useState(null);
const [approvalDialog, setApprovalDialog] = useState(false);
const [approvalStatus, setApprovalStatus] = useState("");
const [approvalReason, setApprovalReason] = useState("");
const [approvalCandidate, setApprovalCandidate] = useState(null);
const [confirmCreateDialog, setConfirmCreateDialog] = useState(false);
const [ocrCandidateData, setOcrCandidateData] = useState(null);
const [csvDialogOpen, setCsvDialogOpen] = useState(false);
const [csvFile, setCsvFile] = useState(null);
const [csvUploading, setCsvUploading] = useState(false);
const [csvResult, setCsvResult] = useState(null);
const [csvPreview, setCsvPreview] = useState([]);
const requiredCsvHeaders = ["Project", "Aadharno"];

const safeLogClientAction = (action, module, metadata = {}) => {
  logClientAction(action, module, metadata).catch((err) => {
    console.warn("Client log failed:", err.response?.status || err.message);
  });
};

const getCsvHeaders = (text) => {
  const headerLine = text.split(/\r?\n/).find((line) => line.trim());
  if (!headerLine) return [];

  return headerLine
    .split(",")
    .map((header) => header.trim().replace(/^"|"$/g, ""));
};

const handleCsvFileChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  setCsvResult(null);
  setCsvPreview([]);

  if (!file.name.toLowerCase().endsWith(".csv")) {
    toast.error("Please select a valid CSV file");
    e.target.value = "";
    return;
  }

  if (file.size > 5 * 1024 * 1024) {
    toast.error("File size must be less than 5MB");
    e.target.value = "";
    return;
  }  

  const reader = new FileReader();
  reader.onload = (event) => {
    const text = event.target.result || "";
    const headers = getCsvHeaders(text);
    const missingHeaders = requiredCsvHeaders.filter(
      (header) => !headers.includes(header)
    );

    if (missingHeaders.length) {
      toast.error(`Missing CSV column: ${missingHeaders.join(", ")}`);
      setCsvFile(null);
      e.target.value = "";
      return;
    }

    const rows = text.split(/\r?\n/).filter(Boolean).slice(0, 6);
    setCsvFile(file);
    setCsvPreview(rows);
  };
  reader.onerror = () => {
    toast.error("Could not read CSV file");
    setCsvFile(null);
    e.target.value = "";
  };
  reader.readAsText(file);
};

const handleCsvUpload = async () => {
  if (!csvFile) {
    toast.error('Please select a CSV file');
    return;
  }

  try {
    setCsvUploading(true);
    toast.loading("Uploading CSV...", { id: "csv-upload" });

    const res = await uploadCandidateCsv(csvFile);

    setCsvResult(res.data);
    toast.success(res.data?.message || "CSV uploaded successfully", {
      id: "csv-upload",
    });
    setPage(0);
    setTimeout(fetchCandidates, 800);

  } catch (err) {
    console.error(err);
    const errorMsg =
      err.response?.status === 403
        ? "You do not have permission to upload CSV. Please check backend role access for this account."
        : err.response?.data?.message || "Upload failed";
    toast.error(errorMsg, { id: "csv-upload" });
  } finally {
    setCsvUploading(false);
  }
};

const resetCsvUpload = () => {
  setCsvFile(null);
  setCsvPreview([]);
  setCsvResult(null);
  setCsvDialogOpen(false);
};
  useEffect(() => {
    fetchCandidates();
  }, [page, rowsPerPage, selectedLocation, search]);
  
useEffect(() => {
  const fetchLocations = async () => {
    try {
      const res = await getAllBranches();

      // ✅ IMPORTANT: access res.data.data
      const locations = [
        ...new Set(
          res.data.data
            .map((branch) => branch.location?.trim())
            .filter(Boolean)
        ),
      ];

      setBranchLocations(locations);
    } catch (error) {
      console.error("Failed to load locations", error);
    }
  };

  fetchLocations();
}, []);

 
useEffect(() => {
  const loadMyLocation = async () => {
    if (role !== "branchUser") return;

    try {
      const res = await getMyBranch();
      const branch = res.data;

      // 🔥 THIS IS THE KEY
      setSelectedLocation(branch.location);
    } catch (err) {
      console.error("Failed to load branch location", err);
    }
  };

  loadMyLocation();
}, [role]);


  const fetchCandidates = async () => {
    try {
      setLoadingTable(true);

    const res = await getAllCandidates(
    page + 1,
    rowsPerPage,
    selectedLocation,
    search
  );


      setData(res.data.data);
      setTotal(res.data.total);

      // Extract unique locations from results (first time only)
      if (locations.length === 0) {
        const unique = [
          ...new Set(res.data.allLocations || res.data.data.map((c) => c.location)),
        ];
        setLocations(unique);
      }
    } catch (error) {
      console.error("Error fetching candidates:", error);
    } finally {
      setLoadingTable(false);
    }
  };

    const handleChange = (key) => (e) => {
      const value = e.target.value;
      setForm((prev) => ({ ...prev, [key]: value }));
    };

const openCreate = async () => {
  setForm(emptyCandidate);
  setEditingId(null);
  setPrograms([]);
  setOpenDrawer(true);

  try {
    // 🔑 ADMIN
    if (role === "admin") {
      const res = await getAllProjects();
      const uniqueProjects = [
        ...new Set(res.data.map((p) => p.projectName)),
      ];
      setProjects(uniqueProjects);
    }

    // 🔑 BRANCH USER
    else {
      const res = await getMyBranch(); // 👈 branch API
      const branch = res.data;

      setForm((prev) => ({
        ...prev,
        project: branch.project,
        program: branch.program,
        location: branch.location,   // ✅ IMPORTANT FIX
      }));

      setProjects([branch.project]);
      setPrograms([branch.program]);
    }
  } catch (error) {
    console.error("Load error:", error);
  }
};



  const openEdit = async (candidate) => {
    console.log("EDIT CLICKED:", candidate._id);
  setEditingId(candidate._id);
  setOpenDrawer(true);

  try {
    // preload form
    setForm({ ...emptyCandidate, ...candidate });

    // ADMIN
    if (role === "admin") {
      const projRes = await getAllProjects();
      const uniqueProjects = [
        ...new Set(projRes.data.map((p) => p.projectName)),
      ];
      setProjects(uniqueProjects);

      if (candidate.project) {
        const progRes = await getProgramsByProject(candidate.project);
        setPrograms(progRes.data || []);
      }
    }

    // BRANCH USER
    else {
      const res = await getMyBranch();
      const branch = res.data;

      setProjects([branch.project]);
      setPrograms([branch.program]);

      setForm((prev) => ({
        ...prev,
        project: branch.project,
        program: branch.program,
        location: branch.location,
      }));
    }
  } catch (err) {
    console.error("Edit load failed", err);
    toast.error("Failed to load candidate for editing");
  }
};


 
// const remainingFields = Object.keys(emptyCandidate).filter(
//   (f) => !excludedFields.includes(f)
// );


 
const saveCandidate = async () => {
  if (!validateForm()) return;

  if (!editingId && aadharStatus === "exists") {
    toast.error("Aadhaar already registered");
    return;
  }

  setSaving(true);
  setOpenDrawer(false);
  toast.loading("Saving candidate...", { id: "save" });

  try {
    const formData = new FormData();

    for (const key in form) {
      const value = form[key];

      if (value === null || value === undefined || value === "") continue;

      // ✅ FILE FIELDS — send ONLY if new file selected
      if (["aadharFile", "dlFile", "otherFile"].includes(key)) {
        if (value instanceof File) {
          formData.append(key, value); // 🚀 DIRECT FILE (NO COMPRESSION)
        }
        continue; // 🔒 DO NOT append string paths
      }

      // ✅ NORMAL FIELDS
      formData.append(key, value);
    }

    if (editingId) {
      await updateCandidate(editingId, formData);
    } else {
      await createCandidate(formData);
    }

    toast.success("Saved successfully", { id: "save" });
    setTimeout(fetchCandidates, 800);
  } catch (err) {
    console.error(err);
    toast.error("Save failed", { id: "save" });
  } finally {
    setSaving(false);
  }
};






    const askDelete = (id) => {
      setDeleteId(id);
      setDeleteDialogOpen(true);
    };

    const performDelete = async () => {
      try {
        await deleteCandidate(deleteId);
        setDeleteDialogOpen(false);
        fetchCandidates();
        alert("Deleted");
      } catch (error) {
        console.error("Delete error:", error);
      }
    };
const handleProjectChange = async (e) => {
  const project = e.target.value;

  setForm((prev) => ({
    ...prev,
    project,
    program: "",
  }));

  if (project) {
    const res = await getProgramsByProject(project);
    setPrograms(res.data);
  } else {
    setPrograms([]);
  }
};


    // View popup component
    const DetailItem = ({ label, value }) => (
      <div>
        <p className="text-sm text-gray-500">{label}</p>
        <p className="font-semibold text-gray-800">{value || "—"}</p>
      </div>
    );
  const fieldLabels = {
    project: "Project",
    location: "Location",
    // status: "Status",
    batchId: "Batch ID",
    name: "Candidate Name",
    fathersName: "Father's Name",
    mothersName: "Mother's Name",
    maritalStatus: "Marital Status",
    aadharNumber: "Aadhar Number",
    dob: "Date of Birth",
    gender: "Gender",
    caste: "Caste",
    address: "Address",

    religion: "Religion",
    vulnerability: "Vulnerability",
    annualIncome: "Annual Income",
    qualification: "Qualification",
    contactNumber: "Contact Number",
    assessmentDate: "Assessment Date",
      dlIssueDate: "DL Issue Date",
    dlAuthority: "DL Issuing Authority",
    mobileNumber: "Mobile Number",
    experienceYears: "Experience (Years)",
    employerName: "Present Employer Name",
    employerAddress: "Employer Address & Contact No",
    dlNo: "DL Number",
    dlType: "DL Type",
    licenseExpiryDate: "License Expiry Date",
    dependentFamilyMembers: "Dependent Family Members",
    ownerOrDriver: "Owner / Driver",
    abha: "ABHA Number",
    result: "Result",
    certificateNo: "Certificate Number",
    remarks: "Remarks",
    ekycRemarks: "eKYC Remarks",
    ekycRegisteredEmail: "eKYC Registered Email",
    barCode: "Bar Code",
aadharFile: "Aadhar Upload",
dlFile: "DL Upload",
otherFile: "Other Documents",

  
  };

const exportExcel = async () => {
  if (!fromDate || !toDate) {
    alert("Please select start and end date");
    return;
  }

  try {
    setExportLoading(true); // show "Downloading..."

    const res = await exportCandidates(fromDate, toDate);

    const blob = new Blob([res.data], {
      type: "text/csv;charset=utf-8;",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = "Candidates.csv"; // ✅ CSV
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    setExportDialog(false);
  } catch (err) {
    console.error(err);
    alert("Export failed");
  } finally {
    setExportLoading(false);
  }
};



const processAadhaar = async () => {
  try {
    if (!scanImage) {
      toast.error("Please upload Aadhaar image");
      return;
    }

    setScanning(true);

    toast.loading("Scanning Aadhaar...", {
      id: "aadhaar-scan",
    });

    const response = await scanAadhaarOCR(scanImage);

    const {
      aadharNumber,
      name,
      fathersName,
      dob,
    } = response.data;

    toast.dismiss("aadhaar-scan");

    if (!aadharNumber) {
      toast.error("Aadhaar number not detected");
      return;
    }

    const res = await checkAadhar(aadharNumber);

    if (res.data.exists) {
      toast.error("Candidate already registered");

      setSelectedCandidate(
        res.data.candidate
      );

      setViewDialogOpen(true);
    } else {
      setOcrCandidateData({
        aadharNumber,
        name,
        fathersName,
        dob: dob
          ? dob.split("/").reverse().join("-")
          : "",
      });

      setConfirmCreateDialog(true);
    }

    setScanDialog(false);
  } catch (error) {
    console.error(error);

    toast.error(
      error?.response?.data?.message ||
        "OCR Scan Failed"
    );
  } finally {
    setScanning(false);
  }
};
//  const preprocessImage = async (file) => {
//   const img = await createImageBitmap(file);

//   const canvas = document.createElement("canvas");
//   const ctx = canvas.getContext("2d");

//   canvas.width = img.width;
//   canvas.height = img.height;

//   ctx.drawImage(img, 0, 0);

//   // Increase contrast
//   const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
//   const data = imageData.data;

//   for (let i = 0; i < data.length; i += 4) {
//     const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
//     const value = avg > 120 ? 255 : 0;

//     data[i] = data[i + 1] = data[i + 2] = value;
//   }

//   ctx.putImageData(imageData, 0, 0);

//   return canvas;
// };

const startCamera = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: { ideal: "environment" }, // back camera
        width: { ideal: 1920 },
        height: { ideal: 1080 },
      },
      audio: false,
    });

    setCameraStream(stream);
    setCameraOpen(true);

    setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play();
      }
    }, 200); // small delay ensures videoRef exists
  } catch (err) {
    console.error(err);
    toast.error("Camera access denied");
  }
};
const captureImage = () => {
  const video = videoRef.current;
  const canvas = canvasRef.current;

  const scale = 2; // higher quality

  canvas.width = video.videoWidth * scale;
  canvas.height = video.videoHeight * scale;

  const ctx = canvas.getContext("2d");
  ctx.scale(scale, scale);
  ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);

  canvas.toBlob((blob) => {
    const file = new File([blob], "aadhaar.jpg", { type: "image/jpeg" });
    setScanImage(file);
    stopCamera();
  }, "image/jpeg", 1);
};
const stopCamera = () => {
  cameraStream?.getTracks().forEach((track) => track.stop());
  setCameraStream(null);
  setCameraOpen(false);
};
const nonRequiredFields = [
  // "status",
  "batchId",
  "certificateNo",
  "barCode",
  "result",
  "ekycRegisteredEmail",
  "abha",
  "remarks",
  "employerAddress",
  "ekycRemarks",
  "vulnerability"

];
const adminOnlyFields = [
  "result",
  "certificateNo",
  "barCode",
  "batchId",
];

const validateForm = () => {
  /* ================= RELIGION ================= */
  if (form.religion === "Others" && !form.religionOther?.trim()) {
    toast.error("Please enter religion");
    return false;
  }

  /* ================= REQUIRED FILES (CREATE ONLY) ================= */
if (!editingId) {
  if (!form.aadharFile) {
    toast.error("Please upload Aadhaar document");
    return false;
  }

  if (!form.dlFile) {
    toast.error("Please upload Driving License document");
    return false;
  }
}

  /* ================= GENERAL REQUIRED FIELDS ================= */
  for (const key of Object.keys(emptyCandidate)) {
    // 🔒 Skip admin-only fields for non-admin users
    if (adminOnlyFields.includes(key) && role !== "admin") continue;

    // Skip optional + non-required fields
    if (optionalFields.includes(key)) continue;
    if (nonRequiredFields.includes(key)) continue;

    // Skip conditional / already validated fields
    if (key === "religionOther") continue;
    if (key === "aadharFile" || key === "dlFile") continue;

    const value = form[key];

    if (
      value === undefined ||
      value === null ||
      value.toString().trim() === ""
    ) {
      toast.error(`Please fill ${fieldLabels[key] || key}`);
      return false;
    }
  }

  return true;
};




const handleAadharChange = async (e) => {
  const value = e.target.value.replace(/\D/g, "");

  setForm((prev) => ({ ...prev, aadharNumber: value }));

  if (value.length < 12) {
    setAadharStatus("invalid");
    return;
  }

  if (value.length > 12) return;

  try {
    setAadharStatus("checking");
    const res = await checkAadhar(value);

    if (res.data.exists) {
      setAadharStatus("exists");
    } else {
      setAadharStatus("available");
    }
  } catch (err) {
    console.error(err);
    setAadharStatus(null);
  }
};
const handleAbhaChange = (e) => {
  const value = e.target.value.replace(/\D/g, "");

  setForm((prev) => ({ ...prev, abha: value }));

  if (value.length === 0) {
    setAbhaError("");
  } else if (value.length !== 14) {
    setAbhaError("ABHA must be 14 digits");
  } else {
    setAbhaError("");
  }
};
const handleContactChange = (e) => {
  const value = e.target.value.replace(/\D/g, "");

  setForm((prev) => ({ ...prev, contactNumber: value }));

  if (value.length === 0) {
    setContactError("");
  } else if (value.length !== 10) {
    setContactError("Contact number must be 10 digits");
  } else {
    setContactError("");
  }
};


const FILE_BASE_URL = "https://astrometric-kris-additionally.ngrok-free.dev"
// const FILE_BASE_URL = "http://localhost:5000"

  

const getFileUrl = (value) => {
  if (!value) return "";

  // Always force /uploads
  return `${FILE_BASE_URL}/${value}`;
};

    return (
      <Box p={3}>
{/* ================= TOP SEARCH ================= */}
<Box
  sx={{
    display: "flex",
    alignItems: "center",
    gap: 2,
    mb: 3,
    flexWrap: "wrap",
  }}
>

 
 <div className="relative w-full max-w-xl">
  <div className="relative flex items-center h-[56px] rounded-full bg-white/80 backdrop-blur-xl border border-gray-200 shadow-md">

    <span className="pl-5 text-gray-400">
      <MagnifyingGlassIcon className="w-5 h-5" />
    </span>

    <input
      type="text"
      value={search}
      onChange={(e) => {
        setSearch(e.target.value);
        setPage(0);
      }}
      placeholder="Search by Name, Aadhaar or Mobile"
      className="
        flex-1 h-full bg-transparent px-4
        text-sm text-gray-700 placeholder-gray-400
        focus:outline-none
      "
    />

    {search && (
      <>
        <div className="h-6 w-px bg-gray-300 mx-1"></div>
        <button
          onClick={() => {
            setSearch("");
            setPage(0);
          }}
          className="mr-4 w-8 h-8 rounded-full flex items-center justify-center
                     text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition"
        >
          <XMarkIcon className="w-4 h-4" />
        </button>
      </>
    )}
  </div>
</div>
<div className="relative w-full sm:w-60">
  <div className="relative flex items-center h-[56px] rounded-full bg-white/80 backdrop-blur-xl border border-gray-200 shadow-md">

    {/* 📍 Icon */}
    <span className="pl-5 text-gray-400">
      <i className="ri-map-pin-line text-lg"></i>
    </span>

   {role === "branchUser" ? (
  <input
    value={selectedLocation}
    disabled
    className="
      flex-1 h-full bg-transparent
      pl-3 pr-4
      text-sm text-gray-700
      cursor-not-allowed
    "
  />
) : (
  <select
    value={selectedLocation}
    onChange={(e) => {
      setSelectedLocation(e.target.value);
      setPage(0);
    }}
    className="
      flex-1 h-full bg-transparent
      pl-3 pr-10
      text-sm text-gray-700
      appearance-none
      focus:outline-none
      cursor-pointer
    "
  >
    <option value="">All Locations</option>
    {locations.map((loc) => (
      <option key={loc} value={loc}>
        {loc}
      </option>
    ))}
  </select>
)}


    {/* ⬇ Arrow (ADMIN ONLY) */}
    {role !== "branchUser" && (
      <span className="absolute right-4 text-gray-400 pointer-events-none">
        <svg
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </span>
    )}
  </div>
</div>



</Box>



    
<Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
  
<Box
  sx={{
    width: "100%",
    mb: 3,
    display: "flex",
    flexWrap: "wrap",
    gap: 2,
    alignItems: "center",
    justifyContent: "space-between",

    "@media (max-width: 640px)": {
      flexDirection: "column",
      alignItems: "stretch",
    },
  }}
>
  
  

  
  

<Box
  className="
    w-full
    flex items-center justify-between
    gap-4
    overflow-x-auto
    pb-2
    scrollbar-hide
  "
>
  {/* LEFT ACTIONS */}
  <div className="flex gap-3 shrink-0">
    {/* CHECK AADHAAR */}
    <button
      onClick={() => {
    safeLogClientAction("CHECK_AADHAAR", "Candidate", {
      source: "button",
    });

    setCheckAadharValue("");
    setAadharCheckStatus("");
    setAadharDialogOpen(true);
  }}
      className="
        flex items-center gap-2
        h-[44px]
        px-5
        rounded-xl
        bg-gradient-to-r from-orange-400 to-orange-500
        text-white
        font-semibold
        shadow-md
        hover:from-orange-500 hover:to-orange-600
        transition
        whitespace-nowrap
      "
    >
      <IdentificationIcon className="w-5 h-5" />
      Check Aadhaar
    </button>

    {/* SCAN AADHAAR */}
  <button
  onClick={() => {
    safeLogClientAction("SCAN_AADHAAR", "Candidate", {
      source: "button",
    });

    setScanDialog(true);
  }}
 

     
      className="
        flex items-center gap-2
        h-[44px]
        px-5
        rounded-xl
        bg-indigo-600
        text-white
        font-medium
        shadow-md
        hover:bg-indigo-700
        transition
        whitespace-nowrap
      "
    >
      <CameraIcon className="w-5 h-5" />
      Scan Aadhaar
    </button>
  </div>

  {/* RIGHT ACTIONS */}
  <div className="flex gap-3 shrink-0 ml-auto">
    {/* EXPORT */}
    {/* <button
      onClick={() => setExportDialog(true)}
      className="
        flex items-center gap-2
        h-[44px]
        px-5
        rounded-xl
        border border-gray-300
        bg-white
        text-gray-700
        font-medium
        shadow-sm
        hover:bg-gray-50
        transition
        whitespace-nowrap
      "
    >
      <DocumentArrowDownIcon className="w-5 h-5" />
      Export Excel
    </button> */}
<div className="relative group">
  <button
    disabled
    className="
      flex items-center gap-2
      h-[44px]
      px-5
      rounded-xl
      border border-gray-300
      bg-gray-100
      text-gray-400
      font-medium
      shadow-sm
      cursor-not-allowed
      whitespace-nowrap
    "
  >
    <DocumentArrowDownIcon className="w-5 h-5" />
    Export Excel
  </button>

  {/* TOOLTIP */}
  <div
    className="
      absolute -top-9 left-1/2 -translate-x-1/2
      px-3 py-1
      rounded-md
      bg-gray-900
      text-white text-xs
      opacity-0
      group-hover:opacity-100
      transition
      pointer-events-none
      whitespace-nowrap
    "
  >
    Coming soon
  </div>
</div>


{role === "superAdmin" && (
  <button
    onClick={() => {
      safeLogClientAction('CSV_UPLOAD_CLICK', 'Candidate', { source: 'button' });
      setCsvDialogOpen(true);
    }}
    className="
      flex items-center gap-2
      h-[44px]
      px-5
      rounded-xl
      bg-purple-600
      text-white
      font-semibold
      shadow-md
      hover:bg-purple-700
      transition
      whitespace-nowrap
    "
  >
    <DocumentArrowDownIcon className="w-5 h-5" />
    Upload CSV
  </button>
)} 
    {/* CREATE */}
    <button
      onClick={openCreate}
      className="
        flex items-center gap-2
        h-[44px]
        px-6
        rounded-xl
        bg-emerald-600
        text-white
        font-semibold
        shadow-md
        hover:bg-emerald-700
        transition
        whitespace-nowrap
      "
    >
      <PlusIcon className="w-5 h-5" />
      Create Candidate
    </button>
  </div>
</Box>



</Box>


  </Box>



    <TableContainer
      component={Paper}
      sx={{
        borderRadius: "16px",
        boxShadow: "0 8px 30px rgba(0,0,0,0.1)",
        overflowX: "auto",
      }}
    >
      <Table sx={{ minWidth: 900 }}>
        {/* ================= TABLE HEAD ================= */}
        <TableHead>
          <TableRow
            sx={{
              background: "linear-gradient(to right, #eef2ff, #e0e7ff)",
            }}
          >
            <TableCell>#</TableCell>
            <TableCell>Candidate</TableCell>

            <TableCell sx={{ display: { xs: "none", sm: "table-cell" } }}>
              Location
            </TableCell>

            <TableCell sx={{ display: { xs: "none", md: "table-cell" } }}>
              Aadhaar No
            </TableCell>

            <TableCell sx={{ display: { xs: "none", md: "table-cell" } }}>
              Contact
            </TableCell>

            <TableCell sx={{ display: { xs: "none", lg: "table-cell" } }}>
              Created Date
            </TableCell>
<TableCell>Status</TableCell>

            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>

        {/* ================= TABLE BODY ================= */}
        <TableBody>
          {loadingTable ? (
            <TableRow>
              <TableCell colSpan={7} align="center">
                Loading...
              </TableCell>
            </TableRow>
          ) : data.length ? (
            data.map((c, index) => (
              <TableRow key={c._id} hover>
                {/* Index */}
                <TableCell>
                  <strong>{page * rowsPerPage + index + 1}</strong>
                </TableCell>

                {/* Candidate */}
                <TableCell>
                  <Box display="flex" alignItems="center" gap={2}>
                    <div className="w-10 h-10 rounded-full bg-indigo-200 flex items-center justify-center shadow">
                      <span className="text-indigo-700 font-bold">
                        {c.name?.charAt(0)?.toUpperCase()}
                      </span>
                    </div>

                    <div>
                      <p className="font-semibold">{c.name?.toUpperCase()}</p>

                      {/* Mobile-only info */}
                      <p className="text-xs text-gray-500 sm:hidden">
                        {c.location}
                      </p>
                    </div>
                  </Box>
                </TableCell>

                {/* Location */}
                <TableCell sx={{ display: { xs: "none", sm: "table-cell" } }}>
                  {c.location}
                </TableCell>

                {/* Aadhaar */}
                <TableCell sx={{ display: { xs: "none", md: "table-cell" } }}>
                  {c.aadharNumber}
                </TableCell>

                {/* Contact */}
                <TableCell sx={{ display: { xs: "none", md: "table-cell" } }}>
                  {c.contactNumber}
                </TableCell>

                {/* Created Date */}
                <TableCell sx={{ display: { xs: "none", lg: "table-cell" } }}>
                  {c.createdAt
                    ? new Date(c.createdAt).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })
                    : "—"}
                </TableCell>
<TableCell>
  <span
    className={`px-3 py-1 rounded-full text-xs font-bold
      ${
        c.approvalstatus === "Approved"
          ? "bg-green-100 text-green-700"
          : c.approvalstatus === "Rejected"
          ? "bg-red-100 text-red-700"
          : "bg-yellow-100 text-yellow-700"
      }
    `}
  >
    {c.approvalstatus}
  </span>

  {c.approvalstatus === "Rejected" && c.approvalReason && (
    <p className="text-xs text-red-600 mt-1">
      Reason: {c.approvalReason}
    </p>
  )}
</TableCell>


                {/* Actions */}
                <TableCell>
                  <Box display="flex" gap={1}>
{role === "admin" && c.approvalstatus === "Pending" && (
  <button
    onClick={() => {
      setApprovalCandidate(c);
      setApprovalStatus("");
      setApprovalReason("");
      setApprovalDialog(true);
    }}
    className="p-2 rounded-lg bg-green-100 hover:bg-green-200"
  >
    <CheckCircleIcon className="w-5 h-5 text-green-600" />
  </button>
)}

                    <button
                      onClick={() => {
                        setSelectedCandidate(c);
                        setViewDialogOpen(true);
                      }}
                      className="p-2 rounded-lg bg-white shadow hover:bg-gray-100"
                    >
                      <BiShow size={18} className="text-blue-600" />
                    </button>

                 <button
  type="button"   // 🔴 IMPORTANT
  onClick={() => openEdit(c)}
  className="p-2 rounded-lg bg-white shadow hover:bg-yellow-100"
>
  <BiEdit size={18} className="text-yellow-600" />
</button>


                    <button
                      onClick={() => askDelete(c._id)}
                      className="p-2 rounded-lg bg-white shadow hover:bg-red-100"
                    >
                      <BiTrash size={18} className="text-red-600" />
                    </button>
                  </Box>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={7} align="center">
                No candidates found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      {/* ================= PAGINATION ================= */}
      <TablePagination
        component="div"
        count={total}
        page={page}
        onPageChange={(e, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
        rowsPerPageOptions={[5, 10, 25]}
      />
    </TableContainer>

  {/* DRAWER */}
  <Drawer
    anchor="right"
    open={openDrawer}
    onClose={() => setOpenDrawer(false)}
    PaperProps={{
      sx: {
        width: { xs: "100%", sm: "80%", md: "60%", lg: "50%", xl: "60%" },
        backgroundColor: "#ffffff",
        p: 0,
      },
    }}
  >
    <Box
      sx={{
        p: 4,
        maxHeight: "100vh",
        overflowY: "auto",
        background: "#f9fafb",
      }}
    >
      {/* HEADER */}
      <Typography variant="h5" fontWeight="bold" mb={3} color="gray.800">
        {editingId ? "Edit Candidate" : "Create Candidate"}
      </Typography>

      {/* FORM WRAPPER */}
      <Box
        sx={{
          p: 3,
          borderRadius: 3,
          // background: "white",
          // boxShadow: "0px 4px 18px rgba(0,0,0,0.08)",
        }}
      >

<div className="flex flex-col">
  <label className="text-sm font-semibold text-gray-700 mb-2">
    Project
  </label>

  <div className="flex flex-wrap gap-3">
    {projects.map((p) => {
      const active = form.project === p;

      return (
        <button
          key={p}
          type="button"
          disabled={role === "branchUser"}
          onClick={() => {
            handleProjectChange({ target: { value: p } });
          }}
          className={`
            px-5 py-2
            rounded-full
            border
            text-sm font-medium
            transition
            ${
              active
                ? "bg-indigo-600 text-white border-indigo-600"
                : "bg-white text-gray-700 border-gray-300 hover:bg-indigo-50"
            }
            ${role === "branchUser" && "cursor-not-allowed opacity-70"}
          `}
        >
          {p}
        </button>
      );
    })}
  </div>
</div>

{form.project && (
  <div className="flex flex-col mt-4">
    <label className="text-sm font-semibold text-gray-700 mb-2">
      Program
    </label>

    <div className="flex flex-wrap gap-3">
      {programs.map((prog) => {
        const active = form.program === prog;

        return (
          <button
            key={prog}
            type="button"
            disabled={role === "branchUser"}
            onClick={() =>
              setForm((prev) => ({ ...prev, program: prog }))
            }
            className={`
              px-5 py-2
              rounded-full
              border
              text-sm font-medium
              transition
              ${
                active
                  ? "bg-green-600 text-white border-green-600"
                  : "bg-white text-gray-700 border-gray-300 hover:bg-green-50"
              }
              ${role === "branchUser" && "cursor-not-allowed opacity-70"}
            `}
          >
            {prog}
          </button>
        );
      })}
    </div>
  </div>
)}


<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 mt-5 gap-6">
{finalFieldOrder.map((field) => {

 
if (adminOnlyFields.includes(field) && role !== "admin") {
  return null;
}

    if (field === "religionOther") return null;

    const isRequired =
      !optionalFields.includes(field) &&
      !nonRequiredFields.includes(field);

    return (
      <div key={field} className="flex flex-col">
        <label className="text-sm font-semibold text-gray-700 mb-1">
          {fieldLabels[field] || field}
          {isRequired && <span className="text-red-500 ml-1">*</span>}
        </label>

        {/* ================= AADHAAR ================= */}
        {field === "aadharNumber" ? (
          <div className="relative">
            <input
              value={form.aadharNumber}
              onChange={handleAadharChange}
              maxLength={12}
              inputMode="numeric"
              placeholder="Enter 12-digit Aadhaar"
              className="bg-gray-50 border border-gray-300 rounded-lg px-3 py-2 w-full pr-10"
            />

            <div className="absolute right-3 top-1/2 -translate-y-1/2">
              {aadharStatus === "checking" && (
                <CircularProgress size={16} />
              )}
              {aadharStatus === "available" && (
                <CheckCircleIcon className="w-5 h-5 text-green-600" />
              )}
              {aadharStatus === "exists" && (
                <XCircleIcon className="w-5 h-5 text-red-600" />
              )}
            </div>

            {aadharStatus === "invalid" && (
              <p className="text-xs text-red-600 mt-1">
                Aadhaar must be 12 digits
              </p>
            )}
            {aadharStatus === "exists" && (
              <p className="text-xs text-red-600 mt-1">
                Aadhaar already registered
              </p>
            )}
            {aadharStatus === "available" && (
              <p className="text-xs text-green-600 mt-1">
                New Aadhaar
              </p>
            )}
          </div>
 ) : field === "abha" ? (
          <div>
            <input
              value={form.abha}
              onChange={handleAbhaChange}
              maxLength={14}
              inputMode="numeric"
              placeholder="Enter 14-digit ABHA"
              className="bg-gray-50 border border-gray-300 rounded-lg px-3 py-2"
            />
            {abhaError && (
              <p className="text-xs text-red-600 mt-1">{abhaError}</p>
            )}
          </div>

        /* ================= CONTACT (10 digits) ================= */
        ) : field === "contactNumber" ? (
          <div>
            <input
              value={form.contactNumber}
              onChange={handleContactChange}
              maxLength={10}
              inputMode="numeric"
              placeholder="Enter 10-digit Contact Number"
              className="bg-gray-50 border border-gray-300 rounded-lg px-3 py-2"
            />
            {contactError && (
              <p className="text-xs text-red-600 mt-1">{contactError}</p>
            )}
          </div>
/* ================= MARITAL STATUS ================= */
) : field === "maritalStatus" ? (
  <select
    value={form.maritalStatus}
    onChange={handleChange("maritalStatus")}
    className="bg-gray-50 border border-gray-300 rounded-lg px-3 py-2"
  >
    <option value="">Select Marital Status</option>
    <option value="Single">Single</option>
    <option value="Married">Married</option>
  </select>
  /* ================= ANNUAL INCOME ================= */
) : field === "annualIncome" ? (
  <select
    value={form.annualIncome}
    onChange={handleChange("annualIncome")}
    className="bg-gray-50 border border-gray-300 rounded-lg px-3 py-2"
  >
    <option value="">Select Annual Income</option>
    <option value="Less than 1 Lakh">Less than 1 Lakh</option>
    <option value="1 - 4 Lakhs">1 - 4 Lakhs</option>
    <option value="Above 4 Lakhs">Above 4 Lakhs</option>
  </select>

        /* ================= EXPERIENCE (1–10) ================= */
        ) : field === "experienceYears" ? (
          <select
            value={form.experienceYears}
            onChange={handleChange("experienceYears")}
            className="bg-gray-50 border border-gray-300 rounded-lg px-3 py-2"
          >
            <option value="">Select Experience</option>
            {[...Array(10)].map((_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1} {i + 1 === 1 ? "Year" : "Years"}
              </option>
            ))}
          </select>

        /* ================= FAMILY MEMBERS (1–10) ================= */
        ) : field === "dependentFamilyMembers" ? (
          <select
            value={form.dependentFamilyMembers}
            onChange={handleChange("dependentFamilyMembers")}
            className="bg-gray-50 border border-gray-300 rounded-lg px-3 py-2"
          >
            <option value="">Select Family Members</option>
            {[...Array(10)].map((_, i) => (
              <option key={i + 1} value={i + 1}>
                {i + 1}
              </option>
            ))}
          </select>
/* ================= QUALIFICATION ================= */
) : field === "qualification" ? (
  <select
    value={form.qualification}
    onChange={handleChange("qualification")}
    className="bg-gray-50 border border-gray-300 rounded-lg px-3 py-2"
  >
    <option value="">Select Qualification</option>
    <option value="Not Educated">Not Educated</option>
    <option value="5th">5th</option>
    <option value="6th">6th</option>
    <option value="7th">7th</option>
    <option value="8th">8th</option>
    <option value="9th">9th</option>
    <option value="10th">10th</option>
    <option value="11th">11th</option>
    <option value="12th">12th</option>
    <option value="Graduate">Graduate</option>
    <option value="Post Graduate">Post Graduate</option>
  </select>
/* ================= OWNER / DRIVER ================= */
) : field === "ownerOrDriver" ? (
  <select
    value={form.ownerOrDriver}
    onChange={handleChange("ownerOrDriver")}
    className="bg-gray-50 border border-gray-300 rounded-lg px-3 py-2"
  >
    <option value="">Select Owner / Driver</option>
    <option value="Owner">Owner</option>
    <option value="Driver">Driver</option>
  </select>

     ) : ["aadharFile", "dlFile", "otherFile"].includes(field) ? (
  <input
    type="file"
    onChange={(e) =>
      setForm((prev) => ({ ...prev, [field]: e.target.files[0] }))
    }
    className="bg-gray-50 border border-gray-300 rounded-lg px-3 py-2"
  />
)

        /* ================= FILE UPLOAD ================= */
       : ["aadharFile", "dlFile", "otherFile"].includes(field) ? (
          <input
            type="file"
            onChange={(e) =>
              setForm((prev) => ({ ...prev, [field]: e.target.files[0] }))
            }
            className="bg-gray-50 border border-gray-300 rounded-lg px-3 py-2"
          />

        /* ================= DATE ================= */
        ) : ["dob", "dlIssueDate", "assessmentDate", "licenseExpiryDate"].includes(field) ? (
          <input
            type="date"
            value={form[field]}
            onChange={handleChange(field)}
            className="bg-gray-50 border border-gray-300 rounded-lg px-3 py-2"
          />

        /* ================= GENDER ================= */
        ) : field === "gender" ? (
          <select
            value={form.gender}
            onChange={handleChange("gender")}
            className="bg-gray-50 border border-gray-300 rounded-lg px-3 py-2"
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>

        /* ================= RELIGION ================= */
        ) : field === "religion" ? (
          <>
            <select
              value={form.religion}
              onChange={(e) => {
                const val = e.target.value;
                setForm((prev) => ({
                  ...prev,
                  religion: val,
                  religionOther: val === "Others" ? prev.religionOther : "",
                }));
              }}
              className="bg-gray-50 border border-gray-300 rounded-lg px-3 py-2"
            >
              <option value="">Select Religion</option>
              <option>Hindu</option>
              <option>Islam</option>
              <option>Sikhism</option>
              <option>Christianity</option>
              <option>Buddhism</option>
              <option>Jain</option>
              <option>Others</option>
            </select>

            {form.religion === "Others" && (
              <input
                type="text"
                placeholder="Enter religion"
                value={form.religionOther}
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    religionOther: e.target.value,
                  }))
                }
                className="mt-2 bg-gray-50 border border-gray-300 rounded-lg px-3 py-2"
              />
            )}
          </>

        /* ================= CASTE ================= */
        ) : field === "caste" ? (
          <select
            value={form.caste}
            onChange={handleChange("caste")}
            className="bg-gray-50 border border-gray-300 rounded-lg px-3 py-2"
          >
            <option value="">Select Caste</option>
            <option>SC</option>
            <option>ST</option>
            <option>OBC</option>
            <option>NT</option>
            <option>GEN</option>
          </select>

        /* ================= DL TYPE ================= */
        ) : field === "dlType" ? (
          <select
            value={form.dlType}
            onChange={handleChange("dlType")}
            className="bg-gray-50 border border-gray-300 rounded-lg px-3 py-2"
          >
            <option value="">Select License Type</option>
            <option>LTV</option>
            <option>LMV-TR</option>
            <option>LMV-CAB</option>
            <option>HTV</option>
            <option>PSV</option>
          </select>

        /* ================= LOCATION ================= */
        ) : field === "location" ? (
          role === "branchUser" ? (
            <input
              value={form.location}
              disabled
              className="bg-gray-100 border border-gray-300 rounded-lg px-3 py-2 cursor-not-allowed"
            />
          ) : (
            <select
              value={form.location}
              onChange={handleChange("location")}
              className="bg-gray-50 border border-gray-300 rounded-lg px-3 py-2"
            >
              <option value="">Select Location</option>
              {branchLocations.map((loc) => (
                <option key={loc} value={loc}>
                  {loc}
                </option>
              ))}
            </select>
          )

        /* ================= DEFAULT ================= */
        ) : (
          <input
            value={form[field]}
            onChange={handleChange(field)}
            placeholder={fieldLabels[field]}
            className="bg-gray-50 border border-gray-300 rounded-lg px-3 py-2"
          />
        )}
      </div>
    );
  })}
</div>







        {/* ACTION BUTTONS */}
        <Box mt={4} display="flex" justifyContent="flex-end" gap={2}>
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => setOpenDrawer(false)}
            sx={{ textTransform: "none", px: 4 }}
          >
            Cancel
          </Button>

<Button
  variant="contained"
  color="primary"
  onClick={saveCandidate}
  disabled={saving}   // 🔒 prevent double click
  sx={{ textTransform: "none", px: 4 }}
>
  {saving ? (
    <>
      <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
      Saving...
    </>
  ) : (
    "Save"
  )}
</Button>


        </Box>
      </Box>
    </Box>
  </Drawer>
<Dialog
  open={exportDialog}
  onClose={exportLoading ? null : () => setExportDialog(false)}
  maxWidth="xs"
  fullWidth
>

  <DialogTitle sx={{ fontWeight: "bold" }}>
    Export Candidates
  </DialogTitle>

  <DialogContent>
    <Box display="flex" flexDirection="column" gap={3} mt={1}>
      
      {/* START DATE */}
      <Box>
        <Typography variant="caption" color="text.secondary">
          Start Date
        </Typography>
        <input
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          className="
            w-full mt-1 px-3 py-2
            border border-gray-300
            rounded-lg
            focus:ring-2 focus:ring-indigo-500
            focus:border-indigo-500
          "
        />
      </Box>

      {/* END DATE */}
      <Box>
        <Typography variant="caption" color="text.secondary">
          End Date
        </Typography>
        <input
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          className="
            w-full mt-1 px-3 py-2
            border border-gray-300
            rounded-lg
            focus:ring-2 focus:ring-indigo-500
            focus:border-indigo-500
          "
        />
      </Box>
    </Box>
  </DialogContent>

<DialogActions sx={{ px: 3, pb: 2 }}>
  <Button
    onClick={() => setExportDialog(false)}
    sx={{ textTransform: "none" }}
    disabled={exportLoading} // 🔒 disable cancel
  >
    Cancel
  </Button>

  <Button
    variant="contained"
    onClick={exportExcel}
    sx={{ textTransform: "none", px: 3 }}
    disabled={exportLoading} // 🔒 disable button
  >
    {exportLoading ? (
      <CircularProgress size={22} color="inherit" />
    ) : (
      "Export Excel"
    )}
  </Button>
</DialogActions>

</Dialog>
{exportLoading && (
  <Typography
    variant="body2"
    color="text.secondary"
    textAlign="center"
  >
    Exporting data… please wait
  </Typography>
)}

<Dialog
  open={confirmCreateDialog}
  onClose={() => setConfirmCreateDialog(false)}
  maxWidth="xs"
  fullWidth
>
  <DialogTitle>New Candidate Detected</DialogTitle>

  <DialogContent>
    <Typography>
      Aadhaar is not registered.
      <br />
      Do you want to create a new candidate?
    </Typography>
  </DialogContent>

  <DialogActions>
    <Button
      onClick={() => {
        setConfirmCreateDialog(false);
        toast("Candidate creation cancelled");
      }}
    >
      No
    </Button>

    <Button
      variant="contained"
      onClick={() => {
        setForm({
          ...emptyCandidate,
          ...ocrCandidateData,
        });

        setConfirmCreateDialog(false);
        setOpenDrawer(true);
        toast.success("Candidate data loaded from Aadhaar");
      }}
    >
      Yes
    </Button>
  </DialogActions>
</Dialog>
<Dialog
  open={aadharDialogOpen}
  onClose={() => setAadharDialogOpen(false)}
  maxWidth="xs"
  fullWidth
>
  <DialogTitle fontWeight="bold">
    Aadhaar Verification
  </DialogTitle>

  <DialogContent>
    {/* INPUT */}
    <input
      type="text"
      value={checkAadharValue}
      onChange={(e) => {
        const val = e.target.value.replace(/\D/g, "");
        if (val.length <= 12) setCheckAadharValue(val);
      }}
      placeholder="Enter 12-digit Aadhaar"
      className="w-full mt-2 px-3 py-2 border rounded-lg text-center tracking-widest"
    />

    {checkAadharValue.length > 0 && checkAadharValue.length !== 12 && (
      <p className="text-xs text-red-600 mt-1 text-center">
        Aadhaar must be exactly 12 digits
      </p>
    )}

    {/* STATUS */}
    <Box mt={3} textAlign="center">
      {aadharCheckStatus === "checking" && (
        <>
          <CircularProgress size={22} />
          <p className="text-sm mt-2">Checking Aadhaar…</p>
        </>
      )}

      {aadharCheckStatus === "exists" && (
        <p className="text-red-600 font-semibold">
          Aadhaar already registered
        </p>
      )}

      {aadharCheckStatus === "new" && (
        <p className="text-green-600 font-semibold">
          New Aadhaar detected
        </p>
      )}
    </Box>
  </DialogContent>

  <DialogActions sx={{ px: 3, pb: 3 }}>
    <Button onClick={() => setAadharDialogOpen(false)}>
      Cancel
    </Button>

    {aadharCheckStatus === "exists" ? (
      <Button
        variant="outlined"
        onClick={() => {
          setAadharDialogOpen(false);
          setViewDialogOpen(true);
        }}
      >
        View Candidate
      </Button>
    ) : (
      <Button
        variant="contained"
        disabled={checkAadharValue.length !== 12}
        onClick={async () => {
          setAadharCheckStatus("checking");
          const res = await checkAadhar(checkAadharValue);

          if (res.data.exists) {
            setSelectedCandidate(res.data.candidate);
            setAadharCheckStatus("exists");
          } else {
            setForm((prev) => ({
              ...prev,
              aadharNumber: checkAadharValue,
            }));
            setAadharCheckStatus("new");
          }
        }}
      >
        Check
      </Button>
    )}
  </DialogActions>
</Dialog>


<Dialog
  open={approvalDialog}
  onClose={() => setApprovalDialog(false)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>Approve / Reject Candidate</DialogTitle>

  <DialogContent>
    <Typography fontWeight="bold">
      {approvalCandidate?.name}
    </Typography>

    <Box mt={3}>
      <select
        value={approvalStatus}
        onChange={(e) => setApprovalStatus(e.target.value)}
        className="w-full border rounded px-3 py-2"
      >
        <option value="">Select Action</option>
        <option value="Approved">Approve</option>
        <option value="Rejected">Reject</option>
      </select>
    </Box>

    {approvalStatus === "Rejected" && (
      <Box mt={2}>
        <textarea
          value={approvalReason}
          onChange={(e) => setApprovalReason(e.target.value)}
          placeholder="Enter rejection reason"
          className="w-full border rounded px-3 py-2"
          rows={3}
        />
      </Box>
    )}
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setApprovalDialog(false)}>
      Cancel
    </Button>

    <Button
      variant="contained"
      disabled={
        !approvalStatus ||
        (approvalStatus === "Rejected" && !approvalReason)
      }
      onClick={async () => {
      await approveCandidate(approvalCandidate._id, {
  approvalstatus: approvalStatus,
  approvalReason,
});


        toast.success(`Candidate ${approvalStatus}`);
        setApprovalDialog(false);
        fetchCandidates();
      }}
    >
      Submit
    </Button>
  </DialogActions>
</Dialog>

<Dialog open={scanDialog} onClose={() => setScanDialog(false)} maxWidth="sm" fullWidth>
  <DialogTitle>Scan Aadhaar</DialogTitle>

<DialogContent>
  <Box display="flex" gap={2} alignItems="center">
    
    {/* FILE UPLOAD */}
    <Button variant="outlined" component="label">
      Upload Image
      <input
        hidden
        type="file"
        accept="image/*"
        onChange={(e) => setScanImage(e.target.files[0])}
      />
    </Button>

    {/* CAMERA ICON */}
    <Button
      variant="contained"
      color="secondary"
      onClick={startCamera}
    >
      Open Camera
    </Button>
  </Box>

  {/* CAMERA PREVIEW */}
  {cameraOpen && (
    <Box mt={3} textAlign="center">
      <video
        ref={videoRef}
        autoPlay
        playsInline
        className="w-full rounded border"
      />
      <canvas ref={canvasRef} hidden />

      <Box mt={2} display="flex" gap={2} justifyContent="center">
        <Button variant="contained" onClick={captureImage}>
          Capture
        </Button>
        <Button variant="outlined" onClick={stopCamera}>
          Cancel
        </Button>
      </Box>
    </Box>
  )}

  {/* IMAGE PREVIEW */}
  {scanImage && !cameraOpen && (
    <img
      src={URL.createObjectURL(scanImage)}
      alt="preview"
      className="mt-4 rounded border w-full"
    />
  )}
</DialogContent>
 

<DialogActions>
  <Button
    onClick={() => setScanDialog(false)}
    disabled={scanning}
  >
    Cancel
  </Button>

  <Button
    variant="contained"
    onClick={processAadhaar}
    disabled={scanning}
    startIcon={
      scanning ? <CircularProgress size={20} color="inherit" /> : null
    }
  >
    {scanning ? "Scanning..." : "Scan & Verify"}
  </Button>
</DialogActions>

</Dialog>
<Dialog
  open={csvDialogOpen}
  onClose={csvUploading ? null : resetCsvUpload}
  maxWidth="md"
  fullWidth
>
  <DialogTitle sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1 }}>
    <DocumentArrowDownIcon className="w-6 h-6" />
    Bulk Upload Candidates (CSV)
  </DialogTitle>

  <DialogContent dividers>
    <Box sx={{ space: 2 }}>
      {/* INSTRUCTIONS */}
      <Box sx={{ mb: 3, p: 2, bgcolor: 'blue.50', borderRadius: 1 }}>
        <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
          CSV Format Requirements
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Your CSV file must include these columns:
        </Typography>
        <div className="bg-white p-2 rounded font-mono text-xs border border-blue-200 mb-2">
          <p>Project, Aadharno</p>
        </div>
        <Typography variant="caption" color="text.secondary" display="block">
          Project values like "Linde Hazmat", "Linde Upskilling", and "SSSF Upskilling" are automatically mapped to the correct project and program.
        </Typography>
        <Typography variant="caption" color="text.secondary" display="block">
          Aadharno must contain a valid 12 digit Aadhaar number. Invalid rows will be skipped.
        </Typography>
      </Box>

      {/* FILE UPLOAD */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
          Select CSV File
        </Typography>
        <input
          type="file"
          accept=".csv"
          onChange={handleCsvFileChange}
          disabled={csvUploading}
          className="border p-3 w-full rounded-lg cursor-pointer hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
        />
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
          Maximum file size: 5MB
        </Typography>
      </Box>

      {/* FILE INFO */}
      {csvFile && (
        <Box sx={{ mb: 3, p: 2, bgcolor: 'gray.50', borderRadius: 1 }}>
          <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
            File Selected
          </Typography>
          <Typography variant="body2">
            <strong>Name:</strong> {csvFile.name}
          </Typography>
          <Typography variant="body2">
            <strong>Size:</strong> {(csvFile.size / 1024).toFixed(2)} KB
          </Typography>
        </Box>
      )}

      {/* CSV PREVIEW */}
      {csvPreview.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
            Preview (First 5 rows)
          </Typography>
          <Box
            sx={{
              bgcolor: 'gray.50',
              p: 2,
              borderRadius: 1,
              overflowX: 'auto',
              border: '1px solid',
              borderColor: 'gray.200'
            }}
          >
            <pre className="text-xs whitespace-pre-wrap break-words font-mono">
              {csvPreview.join('\n')}
            </pre>
          </Box>
        </Box>
      )}

      {/* UPLOAD RESULT */}
      {csvResult && (
        <Box
          sx={{
            p: 3,
            borderRadius: 2,
            bgcolor: "#f9fafb",
            border: "1px solid #e5e7eb",
          }}
        >
          <Typography variant="h6" fontWeight="bold" mb={2}>
            📊 Upload Summary
          </Typography>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: 2,
            }}
          >
            <Box className="p-3 rounded-lg bg-gray-100">
              <p className="text-xs text-gray-500">Total Rows</p>
              <p className="font-bold text-lg">{csvResult.totalRows}</p>
            </Box>

            <Box className="p-3 rounded-lg bg-green-100">
              <p className="text-xs text-green-700">Inserted</p>
              <p className="font-bold text-lg text-green-700">
                {csvResult.inserted}
              </p>
            </Box>

            <Box className="p-3 rounded-lg bg-yellow-100">
              <p className="text-xs text-yellow-700">Skipped</p>
              <p className="font-bold text-lg text-yellow-700">
                {csvResult.skipped}
              </p>
            </Box>

            <Box className="p-3 rounded-lg bg-red-100">
              <p className="text-xs text-red-700">Duplicates</p>
              <p className="font-bold text-lg text-red-700">
                {csvResult.duplicates || 0}
              </p>
            </Box>
          </Box>
          {csvResult.duplicates > 0 && (
            <div className="mt-2 text-red-600 text-sm font-semibold">
              ⚠ {csvResult.duplicates} duplicate records found
            </div>
          )}

          {csvResult?.errors?.length > 0 && (
            <Box
              sx={{
                mt: 2,
                p: 2,
                borderRadius: 1,
                bgcolor: "#fff1f2",
                border: "1px solid #fecaca",
                maxHeight: 200,
                overflow: "auto",
              }}
            >
              <Typography fontWeight="bold" color="error">
                ⚠ Duplicate / Error Details
              </Typography>
              {csvResult.errors.map((err, i) => (
                <Typography key={i} variant="caption" display="block">
                  •{" "}
                  {typeof err === "string"
                    ? err
                    : `Row ${err.row || i + 1} - ${err.reason || "Error"}`}
                </Typography>
              ))}
            </Box>
          )}
        </Box>
      )}

      {/* LOADING STATE */}
      {csvUploading && (
        <Box sx={{ textAlign: 'center', py: 2 }}>
          <CircularProgress size={32} sx={{ mb: 1 }} />
          <Typography>Uploading and processing CSV...</Typography>
        </Box>
      )}
    </Box>
  </DialogContent>

  <DialogActions sx={{ p: 2, gap: 1 }}>
    <Button
      onClick={resetCsvUpload}
      disabled={csvUploading}
    >
      {csvResult ? 'Close' : 'Cancel'}
    </Button>
    {!csvResult && (
      <Button
        variant="contained"
        color="primary"
        onClick={handleCsvUpload}
        disabled={!csvFile || csvUploading}
        startIcon={csvUploading ? <CircularProgress size={20} /> : null}
      >
        {csvUploading ? 'Uploading...' : 'Upload CSV'}
      </Button>
    )}
    {csvResult && (
      <Button
        variant="contained"
        color="success"
        onClick={resetCsvUpload}
      >
        Done
      </Button>
    )}
  </DialogActions>
</Dialog>
{/* VIEW POPUP */}
      <Dialog
  open={viewDialogOpen}
  onClose={() => setViewDialogOpen(false)}
  fullWidth
  maxWidth="lg"   // ⭐ WIDER POPUP
  PaperProps={{
    sx: { width: "90%", maxWidth: "1400px" } // ⭐ CUSTOM WIDTH
  }}
>

          <DialogTitle>Candidate Details</DialogTitle>
          <DialogContent dividers>
            {/* ================= APPROVAL STATUS ================= */}
<Box mb={3}>
  <p className="text-sm text-gray-500">Approval Status</p>

  <span
    className={`inline-block px-4 py-1 rounded-full text-sm font-bold
      ${
        selectedCandidate?.approvalstatus === "Approved"
          ? "bg-green-100 text-green-700"
          : selectedCandidate?.approvalstatus === "Rejected"
          ? "bg-red-100 text-red-700"
          : "bg-yellow-100 text-yellow-700"
      }
    `}
  >
    {selectedCandidate?.approvalstatus || "Pending"}
  </span>

  {/* REJECTION REASON */}
  {selectedCandidate?.approvalstatus === "Rejected" &&
    selectedCandidate?.approvalReason && (
      <p className="text-sm text-red-600 mt-2">
        Reason: {selectedCandidate.approvalReason}
      </p>
    )}
</Box>

<div className="grid grid-cols-3 gap-4">
  {Object.keys(emptyCandidate).map((f) => {
    const value = selectedCandidate?.[f];

    if (["aadharFile", "dlFile", "otherFile"].includes(f)) {
      return (
        <div key={f}>
          <p className="text-sm text-gray-500">{fieldLabels[f]}</p>

          {!value ? (
            <p className="text-gray-400">—</p>
          ) : (
<>
<a
  href={getFileUrl(value)}
  target="_blank"
  rel="noopener noreferrer"
  className="text-indigo-600 underline"
>
  Open File
</a>


  {/\.(jpg|jpeg|png|gif)$/i.test(value) && (
    <img
      src={getFileUrl(value)}
      alt="preview"
      className="w-32 h-auto rounded mt-2 border"
    />
  )}
</>

          )}
        </div>
      );
    }

    return (
      <DetailItem
        key={f}
        label={fieldLabels[f] || f.replace(/([A-Z])/g, " $1")}
        value={value}
      />
    );
  })}
</div>


          </DialogContent>
          <DialogActions>
            <Button onClick={() => setViewDialogOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>

        {/* DELETE CONFIRM */}
        <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
          <DialogTitle>Delete Candidate?</DialogTitle>
          <DialogActions>
            <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
            <Button color="error" onClick={performDelete}>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  };

  export default Candidates;
